import { Component } from 'react'
import {JSONFetcher, formatCents} from 'shared'
import {Modal} from 'shared/components/modal'
import {PopoverIcon} from 'shared'

export class CompletedNeeds extends Component {
  state = { data: [], total_entries: 0, showModal: false }

  componentDidMount() {
    JSONFetcher.load({
      url:     this.props.apiUrl,
      success: (response) => { if (response.total_entries > 0) this.setState(response) }
    })
  }

  hideModal = () => {
    this.setState({showModal: false})
  }

  get showMoreNotice() {
    let overflow = this.state.total_entries - 20
    if (overflow > 0) {
      return <p>{ I18n.t('projects.show.completed_needs.more_completed_needs_notice', { more_count: overflow }) }</p>
    }
  }

  get showModalLink() {
    if (!this.state.total_entries) return null
    return <a className='text-grey-dark hover:text-grey-dark font-weight-400 completed-needs-modal-link'
              onClick={() => this.setState({showModal: true})}
           >{ I18n.t('projects.show.completed_needs.link_text') }</a>
  }

  render() {
    let modalBody = this.state.data.map(
      need => <tr key={ need.id } className='generic-popover-constraints'>
        <td>
          <span dangerouslySetInnerHTML={{ __html: need.title }} />
          {' '}
          <PopoverIcon
            popover={ `
              <p>${need.description}</p>
              <p><small>${I18n.t('projects.show.completed_needs.created_date_line', { date: I18n.l('date.formats.short_date_with_week_day', need.created_at) })}</small></p>
            ` }
            icon='info'
          />
        </td>
        <td style={{ textAlign: 'right' }}>
          {formatCents(need.requested_amount_in_cents)}&nbsp;{ I18n.t('projects.show.completed_needs.collected_label') }
        </td>
      </tr>
    )

    return <>
      <div style={{textAlign: 'center'}}>{ this.showModalLink }</div>

      <Modal
        id='completed-needs-modal'
        onHide={this.hideModal}
        show={this.state.showModal}
        header={I18n.t('projects.show.completed_needs.headline')}
        footer={<button type='button' className='btn btn-default' onClick={this.hideModal} aria-hidden='true'>{I18n.t('projects.show.completed_needs.close_link_text')}</button>}
      >
        <p><strong>{I18n.t('projects.show.completed_needs.thank_you_message')}</strong></p>
        <table className='table table-striped'>
          <tbody>
            {modalBody}
          </tbody>
        </table>
        {this.showMoreNotice}
      </Modal>
    </>
  }
}
